import { useEffect, useRef } from 'react';

interface SessionNoticeProps {
  readonly message: string;
}

/**
 * Explains why the previous session ended (US-003 AC-001).
 *
 * Focus is moved here on mount rather than relying on the live region alone: the notice arrives with a
 * whole new document after a forced sign-out, and a region that already contains its text at mount is
 * not announced by most screen reader and browser pairings.
 */
export function SessionNotice({ message }: SessionNoticeProps): React.JSX.Element {
  const noticeRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    noticeRef.current?.focus();
  }, []);

  return (
    <p
      ref={noticeRef}
      tabIndex={-1}
      role="status"
      className="border-line text-muted mb-4 rounded-md border bg-surface-muted px-4 py-3 text-[13px] leading-relaxed"
    >
      {message}
    </p>
  );
}
